{{title}}

<div class="row px-2">
    <div class="col-12 my-3 line "></div>
</div>

<div class="div" *ngIf="movies.length > 0">
    <ul class="list-group list-group-horizontal row">
        <li class="list-group-item col-4 col-md-3 col-lg-2 p-0 border-0" *ngFor="let movie of movies">
            <div class="movie-poster">
                <app-ui-poster [movie]="movie" [mostrarInfo]=true> </app-ui-poster>
            </div>
        </li>
    </ul>
</div>
<div class="div textoSinPeliculasContenedor" *ngIf="movies.length == 0">
    <div class="text-left textoSinPeliculas"> Sin peliculas para mostrar </div>
</div>